import {action, makeObservable, observable, runInAction} from "mobx";
import {Country, HotIoc, IP} from "../models/stats";
import {requests} from "../api";

class CommonStatsStore<T = IP | Country | HotIoc> {
    path = ""
    @observable loading = false
    @observable data: T[] = []
    @observable error = ""

    constructor() {
        makeObservable(this)
    }

    @action
    load() {
        if (this.loading) return
        this.loading = true

        requests.get(this.path)
            .then(data => data.forEach((item: T) => this.addItem(item)))
            .catch(err => runInAction(() => this.error = `error: ${err}`))
            .finally(() => runInAction(() => this.loading = false))
    }

    @action
    addItem(item: T) {
        item = this.addId(item)
        this.data.push(item)
    }

    addId(item: T){return item}
}

export class WorstIpStore extends CommonStatsStore<IP> {
    constructor() {
        super();
        this.path = "/stats/ip"
        this.load()
    }

    addId(item: IP){item.id = this.data.length; return item}
}

export class WorstCountryStore extends CommonStatsStore<Country> {
    constructor() {
        super();
        this.path = "/stats/country"
        this.load()
    }
    addId(item: Country){item.id = this.data.length; return item}
}

export class HotIocStore extends CommonStatsStore<HotIoc> {
    constructor() {
        super();
        this.path = "/stats/ioc"
        this.load()
    }
    addId(item: HotIoc){item.id = this.data.length; return item}
}